import { refreshAccess, can, landing, clearAccess } from '../utils/access';
import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from '@/utils/storage';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login-index.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/',
      component: () => import('@/layout/Layout.vue'),
      redirect: '/dashboard',
      children: [
{ path: 'workspace', component: () => import('../views/Workspace.vue'), meta: { title: '工作台' } },
{ path: 'roles', redirect: { path: '/access-management', query: { tab: 'roles' } } },
{ path: 'access-management', component: () => import('../views/AccessManage.vue'), meta: { title: '用户与权限', permissionsAny: ['users:view', 'roles:view'] } },

        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard.vue'),
          meta: { title: '首页统计', permission: 'dashboard:view' }
        },
        {
          path: 'customers',
          name: 'CustomerManage',
          component: () => import('@/views/CustomerManage.vue'),
          meta: { title: '客户管理', permission: 'customers:view' }
        },
        {
          path: 'purchase',
          name: 'PurchaseManage',
          component: () => import('@/views/PurchaseManage.vue'),
          meta: { title: '进货管理', permission: 'purchases:view' }
        },
        {
          path: 'weighing',
          name: 'WeighingManage',
          component: () => import('@/views/WeighingManage.vue'),
          meta: { title: '地磅称重', permission: 'weighing:view' }
        },
        {
          path: 'reverse-invoice',
          name: 'ReverseInvoiceManage',
          component: () => import('@/views/ReverseInvoiceManage.vue'),
          meta: { title: '反向开票', permission: 'invoices:view' }
        },
        {
          path: 'shipment',
          name: 'ShipmentManage',
          component: () => import('@/views/ShipmentManage.vue'),
          meta: { title: '出货管理', permission: 'shipments:view' }
        },
        {
          path: 'debt-records',
          name: 'DebtManage',
          component: () => import('@/views/DebtManage.vue'),
          meta: { title: '欠账记录', permission: 'debts:view' }
        },
      {
          path: 'freight-records',
          name: 'FreightManage',
          component: () => import('@/views/FreightManage.vue'),
          meta: { title: '运费管理', permission: 'freight:view' }
        },
        {
          path: 'daily-bill',
          name: 'DailyBillManage',
          component: () => import('@/views/DailyBillManage.vue'),
          meta: { title: '每日账单', permission: 'bills:view' }
        },
        {
          path: 'admin-settings',
          name: 'AdminSettings',
          redirect: { path: '/access-management', query: { tab: 'users' } }
        },
        {
          path: 'login-logs',
          name: 'LoginLog',
          component: () => import('@/views/LoginLog.vue'),
          meta: { title: '登录日志', permission: 'logs:view' }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: () => import('@/views/Settings.vue'),
          meta: { title: '系统设置', permission: 'settings:view' }
        }
      ]
    },
    {
      path: '*',
      redirect: '/dashboard'
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  if (!getToken()) { clearAccess(); next(to.path === '/login' ? undefined : '/login'); return; }
  try {
    await refreshAccess();
    if (to.path === '/login') { next(landing()); return; }
    if ((to.meta.permissionsAny && !to.meta.permissionsAny.some(can)) || (to.meta.permission && !can(to.meta.permission))) { next('/workspace'); return; }
    next();
  } catch (_) {
    next(to.path === '/login' || to.path === '/workspace' ? undefined : '/workspace');
  }
});

router.afterEach(to => {
  document.title = `${(to.meta && to.meta.title) || '管理系统'} - 凯安民用`;
});

export default router;
